const ALL_COLORS = [
  "#0048BA",
  "#B0BF1A",
  "#7CB9E8",
  "#C0E8D5",
  "#B284BE",
  "#72A0C1",
  "#EDEAE0",
  "#F0F8FF",
  "#C46210",
  "#EFDECD",
  "#E52B50",
  "#9F2B68",
  "#F19CBB",
  "#AB274F",
  "#D3212D",
  "#3B7A57",
  "#FFBF00",
  "#FF7E00",
  "#9966CC",
  "#A4C639",
];
// const BASE_URL = "http://localhost:8002/api/v1";
const BASE_URL = "https://api.vimotion.mood-me.com/prod";
// const BASE_URL = "https://backend.mood-me.com/eip/api/v1";
const THUMBNAIL_BASE_URL = "https://backend.mood-me.com/eip/";
const IS_LOCAL_MODE = false;

export { ALL_COLORS, BASE_URL, IS_LOCAL_MODE, THUMBNAIL_BASE_URL };
